import {
  deleteServicePartnerCollectionById,
  fetchServicePartnerCollectionById,
} from "@/lib/api/resources/servicePartnerCollections";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Col, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { ServicePartnerCollectionDetailCard } from "./components/ServicePartnerCollectionDetailCard";
import { ServicePartnersCard } from "./components/ServicePartnersCard";

export const ServicePartnersCollectionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const servicePartnerCollectionQuery = useQuery({
    queryKey: ["service-partner-collections", id],
    queryFn: () => fetchServicePartnerCollectionById(id),
  });

  const deleteServicePartnerCollectionMutation = useMutation({
    mutationFn: () => deleteServicePartnerCollectionById(id),
    onSuccess: () => {
      navigate(`/service-partners/collections`);
      message.success("Subnetwerk succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van het subnetwerk",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerCollectionDetailCard
            servicePartnerCollection={servicePartnerCollectionQuery.data}
            isLoading={servicePartnerCollectionQuery.isLoading}
            deleteMutation={deleteServicePartnerCollectionMutation}
          />
        </Col>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnersCard
            servicePartnerCollection={servicePartnerCollectionQuery.data}
            isLoading={servicePartnerCollectionQuery.isLoading}
          />
        </Col>
      </Row>
    </div>
  );
};
